/* eslint-disable react/prop-types */
import { motion } from 'framer-motion';
import React, { useCallback, useState } from 'react';
import { Image as SemanticUIImage } from 'semantic-ui-react';

export function Image({ paddingBottom, src, transform, loadingType = 'lazy', imgStyle, style = {}, className = '', ...rest }) {
  const [loaded, setLoaded] = useState(false);
  const _style = { ...style };
  if (!loaded) {
    _style.visibility = 'hidden';
  }
  if (true) {
    _style.borderRadius = '10px';
  }
  const done = useCallback(() => {
    setLoaded(true);
  }, [setLoaded]);
  return (
    <div style={{ paddingBottom: loaded ? 0 : paddingBottom }} className={`image-loader ${className}`}>
      {!imgStyle && <SemanticUIImage loading={loadingType} {...rest} src={src} style={_style} onLoad={done} />}
      {imgStyle && <motion.img style={{ ...imgStyle, ..._style }} {...rest} src={src} onLoad={done} />}
    </div>
  );
}
